import * as ActionTypes from '../actions'
import { combineReducers } from 'redux'



const messages = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return action.response.messagesCount
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return null
		default:
			return state
	}
}

const registrations = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return action.response.registrationsCount
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return null
		default:
			return state
	}
}

const countsReducer = combineReducers({
	messages,
	registrations
})

export default countsReducer


// WEBPACK FOOTER //
// ./src/reducers/counts.js